"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCartQuantities = exports.getCheckoutItems = exports.getItems = void 0;
var reselect_1 = require("reselect");
var cartSelectors_1 = require("../cartSelectors");
exports.getItems = (0, reselect_1.createSelector)(cartSelectors_1.getCart, function (shoppingCart) {
    return shoppingCart.items || null;
});
exports.getCheckoutItems = (0, reselect_1.createSelector)(cartSelectors_1.getCart, function (shoppingCart) {
    return shoppingCart.checkoutItems || null;
});
exports.getCartQuantities = (0, reselect_1.createSelector)(exports.getCheckoutItems, function (quantities) {
    var skuKeyWithQtyMap = {};
    for (var _i = 0, _a = Object.entries(quantities || {}); _i < _a.length; _i++) {
        var _b = _a[_i], skuKey = _b[0], valueWithExtraInfo = _b[1];
        if (valueWithExtraInfo.quantity) {
            skuKeyWithQtyMap[skuKey] = valueWithExtraInfo.quantity;
        }
    }
    return skuKeyWithQtyMap;
});
